import { defineMessages } from 'react-intl'

export default defineMessages({
  placeholder: {
    id: 'components.PhoneItem.placeholder',
    defaultMessage: 'Please enter phone number',
    description: '手机号placeholder'
  }
})
